<template>
  <section>
    <div class="card panel-white" v-if="displaySection(order)">
      <div class="card-body">
        <label>{{ $t('message.my_reservations.request_additional_hours') }}</label>
        <div class="mt-3">
                <span class="bullet-notification">
                  <i class="fas fa-circle"></i>
                </span>
          {{ $t('message.my_reservations.provider_request_additional_hours') }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['order'],
    methods: {
      displaySection (order) {
        let result = false
        if (order.book_more_hours.length > 0) {
          const orderAdditionalHours = order.book_more_hours[0]
          if (orderAdditionalHours.status === 0 && orderAdditionalHours.sender_type === 'professional' && !orderAdditionalHours.payment_method) {
            result = true
          }
        }
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ConfirmRequestAdditionalHoursSection.vue